import { createContext } from 'react'

const SupplierJourneyContext = createContext()

export default SupplierJourneyContext
